(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('changeLog', {
            templateUrl: 'app/components/change-log/change-log.html',
            controller: changeLogController,
            bindings: {
                changeLog: '<',
                propertyPrefix: '@',
                createdByField: '@',
                createdAtField: '@',
                lastModifiedByField: '@',
                lastModifiedAtField: '@'
            }
        });

    /** @ngInject */
    function changeLogController($translate, moment) {
        var $ctrl = this;

        var defaultCreatedByField = 'createdBy';
        var defaultCreatedAtField = 'createdAt';
        var defaultLastModifiedByField = 'lastModifiedBy';
        var defaultLastModifiedAtField = 'lastModifiedAt';

        $ctrl.$onInit = init;

        function init() {
            $ctrl.dateFormat = $translate.instant('dateTimeSecondsMomentFormat');
            $ctrl.changeLog = $ctrl.changeLog ? JSON.parse($ctrl.changeLog) : {}
            $ctrl.createdByField = $ctrl.createdByField ? $ctrl.createdByField : defaultCreatedByField;
            $ctrl.createdAtField = $ctrl.createdAtField ? $ctrl.createdAtField : defaultCreatedAtField;
            $ctrl.lastModifiedByField = $ctrl.lastModifiedByField ? $ctrl.lastModifiedByField : defaultLastModifiedByField;
            $ctrl.lastModifiedAtField = $ctrl.lastModifiedAtField ? $ctrl.lastModifiedAtField : defaultLastModifiedAtField;
            $ctrl.createdMessage = $translate.instant('changeLog.created');

            collectMetadata();
        }

        function collectMetadata() {
            var changes = $ctrl.changeLog["changes"];
            $ctrl.isCreate = changes[$ctrl.createdByField] !== undefined;

            if ($ctrl.isCreate) {
                collectAuthorField(changes, 'createdByField');
                collectTimeField(changes, 'createdAtField');
            } else {
                collectAuthorField(changes, 'lastModifiedByField');
                collectTimeField(changes, 'lastModifiedAtField');
            }
        }

        function collectAuthorField(changes, fieldName) {
            if (changes[$ctrl[fieldName]]) {
                $ctrl.author = changes[$ctrl[fieldName]].newValue._propertyValue;
                delete changes[$ctrl[fieldName]];
            }
        }

        function collectTimeField(changes, fieldName) {
            if (changes[$ctrl[fieldName]]) {
                const timeValue = changes[$ctrl[fieldName]].newValue;
                const isTimestamp = angular.isNumber(timeValue);
                if (isTimestamp) {
                    $ctrl.time = moment(changes[$ctrl[fieldName]].newValue * 1000).format($ctrl.dateFormat);
                } else {
                    $ctrl.time = moment(changes[$ctrl[fieldName]].newValue).format($ctrl.dateFormat);
                }
                delete changes[$ctrl[fieldName]];
            }
        }
    }
})();
